export const formatLibradoState = (state: $TSMigrationFixMe) => {
  return {
    ajustesDocumentoPorDefectoContacto:
      state?.librado?.ajustesDocumentoPorDefectoContacto,
    configuracion: state?.configuracion,
    cuentasBancarias: state?.librado?.cuentasBancarias,
    direccion: state?.librado?.direccion?.calle,
    divisa: state?.librado?.divisa,
    empresaContactoId: state?.librado?.empresaContactoId,
    empresaId: state?.librado?.empresaId,
    nif: state?.librado?.nif,
    pais: state?.librado?.pais,
    razonSocial: state?.librado?.razonSocial,
    telefonos: state?.librado?.telefonos,
    id: state?.librado?.id,
    telefono: state?.librado?.telefonos[0]?.contacto,
    email: state?.librado?.emails[0]?.contacto,
    emails: state?.librado?.emails,
    cif: state?.librado?.nif,
    provincia: state?.librado?.direccion?.provinciaNombre,
    poblacion: state?.librado?.direccion?.poblacionNombre,
    poblacionId: state?.librado?.direccion?.poblacionId,
    cp: state?.librado?.direccion?.codigoPostal,
  }
}

export const formatLibradorState = (state: $TSMigrationFixMe) => {
  return {
    cif: state?.librador?.nif,
    direccion: state?.librador?.calle,
    divisaAbreviatura: state?.librador?.divisa,
    email: state?.librador?.emails[0]?.contacto,
    pais: state?.librador?.direccion?.pais || "",
    razonSocial: state?.librador?.razonSocial,
    telefono: state?.librador?.telefonos[0]?.contacto || "",
    telefonos: state?.librador?.telefonos,
    id: state?.librador?.id,
    cp: state?.librador?.direccion?.codigoPostal,
    poblacionId: state?.librador?.direccion?.poblacionId,
    poblacion: state?.librador?.direccion?.poblacionNombre,
    provincia: state?.librador?.direccion?.provinciaNombre,
    poblacionExtranjera: state?.librador?.direccion?.poblacionExtranjera,
    empresaContactoId: state?.librador?.empresaContactoId,
  }
}
